import React from 'react';
import { UseFormRegister } from 'react-hook-form';

import IInputs from '../../../interfaces/IInputs';
import './Radio.sass';

interface Props {
	inputName:
		| 'newsLettersAgreement'
		| 'newsAndColaborationAgreement'
		| 'talkCoSpeaker'
		| 'talkCoSpeaker2'
		| 'talkCoSpeaker3';
	label: string;
	register: UseFormRegister<IInputs>;
	defaultChecked?: boolean;
}

function Radio({ inputName, label, register, defaultChecked }: Props) {
	return (
		<label className="radio-default">
			<input
				defaultChecked={defaultChecked}
				{...register(inputName)}
				type="radio"
				className="radio-default__input"
				value={label === 'Yes' ? 'true' : 'false'}
			/>
			<span className="radio-default__trigger" />
			<span className="radio-default__label">{label}</span>
		</label>
	);
}

Radio.defaultProps = {
	defaultChecked: false,
};

export default Radio;
